import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { formatCurrencyField, getStringOrDefault } from "../../utils/utils";
import { ReportField } from "./reportField";
import { observer } from "mobx-react";
import { Ref } from "react";

const useStyles = makeStyles(() => ({
  longTextTypography: {
    fontSize: "14px",
    padding: "16px",
    paddingTop: "10px",
    fontWeight: 400,
  },
}));

interface ValueReconciliationBoxProps {
  valuationValues: any;
  //the options below are for the pages where long comments continue, the defaults give the usual box
  title?: string;
  showValues?: boolean;
  //the comments to show (the part that goes in this page) instead of all the saved comments
  comments?: string;
  //the element that holds the comments text, used to measure how much text fits in a page
  commentsRef?: Ref<HTMLElement>;
}

export const ValueReconciliationBox = observer(({ valuationValues, title = "Value Reconciliation", showValues = true, comments, commentsRef }: ValueReconciliationBoxProps) => {
  const classes = useStyles();

  return (<FieldSetBox title={title}>
    <Grid container>
      {showValues && (<>
        <Grid item xs={4}>
          <ReportField
            label="As-Repaired Value"
            value={formatCurrencyField(valuationValues.asRepairedValue)}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="As-Is Value"
            value={formatCurrencyField(valuationValues.asIsValue)}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Site Value"
            value={formatCurrencyField(valuationValues.siteValue)}
            removeRightBorder
          />
        </Grid>
      </>)}
      <Grid item xs={12}>
        <ReportField
          label="Value Reconciliation Comments"
          removeRightBorder
        >
          <Typography className={classes.longTextTypography} ref={commentsRef}>
            {getStringOrDefault(comments ?? valuationValues.valueReconciliationComments)}
          </Typography>
        </ReportField>
      </Grid>
    </Grid>
  </FieldSetBox>);
});